/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { ModelProperty } from '../engine/model-property';
import { FormatPipe } from '../pipe/format.pipe';
import { Cell } from './model/cell';
import { CommonUtils } from '../tool/common-utils';

export class ExportUtils {
  /**
   * Truncate header cell if text is longer than charMax
   */
  static truncate(text: string, charMax: number): string {
    return text.length > charMax
      ? text.substring(0, charMax - 1) + '...'
      : text;
  }

  /**
   * Convert row to array of string data to display on cell
   * @param data brut data
   * @param properties list of Data Model Properties
   */
  static convertDataToRow(
    data: any,
    properties: ModelProperty[],
    csv = false
  ): Cell[] {
    const row: Cell[] = [];
    for (const property of properties) {
      let text = data[property.id];
      if (text !== null && text !== undefined) {
        if (text instanceof Array) {
          text = FormatPipe.arrayFactory(text, property);
        } else if (text instanceof Date) {
          text = CommonUtils.convertDateToString(text);
        } else if (typeof text === 'object') {
          text = FormatPipe.objectFactory(text, property);
        } else if (
          typeof text === 'number' ||
          property.type === 'number' ||
          property.editType === 'number'
        ) {
          if (
            Object.hasOwn(property, 'formatter') &&
            property.formatter.type === 'round'
          ) {
            text = FormatPipe.roundFactory(data, property);
          }
          text = (text + '').replace('.', ',');
        }
      } else {
        text = '-';
      }
      let str = text + '';
      if (csv) {
        str = '"' + str.split('"').join('""') + '"';
      }
      row.push(new Cell(str.trim(), property.align));
    }
    return row;
  }

  /**
   * Generate header (first row)
   * @param columns list of property of DataModel
   */
  static generateHeader(columns: ModelProperty[], group = false): string[] {
    void group;
    const header: string[] = [];
    for (const column of columns) {
      header.push(column.title);
    }
    return header;
  }
}
